module.exports = __webpack_public_path__ + "img/icon-success.61ac718e.svg";